<template>
  <div class="attach-tree-node">
    <a-popover placement="right" title="" trigger="hover">
      <template slot="content">
        <div class="tree-intro">
          <h5 :class="{ 'tree-intro-title': record.intro }">{{ title }}</h5>
          <div class="tree-intro-content" v-if="record.intro">
            {{ record.intro }}
          </div>
        </div>
      </template>

      <span
        :style="customStyle"
        class="attach-folder"
        :id="record.id === 0 ? 'attachRootFolder' : null"
        :title="title"
      >
        <a-icon type="folder-open" slot="icon" v-if="record.id == dirId" />
        <a-icon type="folder" slot="icon" v-else />
        {{ title }}
      </span>
    </a-popover>

    <!-- 非根目录才显示，根目录不允许任何操作 -->
    <a-dropdown
      :trigger="['click']"
      v-if="
        (AUTH_ATTACH_DIR_ADD ||
          AUTH_ATTACH_DIR_RENAME ||
          AUTH_ATTACH_FILE_UPLOAD ||
          AUTH_ATTACH_DIR_DELETE) &&
          record.root !== true
      "
      overlayClassName="attach-dropmenu"
      position="topRight"
    >
      <div class="ellipsis-icon">
        <Icon type="EllipsisOutlined" />
      </div>
      <template #overlay>
        <a-menu class="context-menu" @click="handleMenuClick">
          <!-- 上传文件 -->
          <a-menu-item key="upload" v-if="AUTH_ATTACH_FILE_UPLOAD">
            {{ $t('attach_menu_upload') }}
          </a-menu-item>

          <!-- 添加文件夹 -->
          <a-menu-item key="newFolder" v-if="AUTH_ATTACH_DIR_ADD">
            {{ $t('attach_menu_new_folder') }}
          </a-menu-item>

          <!-- 编辑文件夹 -->
          <a-menu-item key="editFolder" v-if="AUTH_ATTACH_DIR_EDIT">
            {{ $t('attach_menu_edit') }}
          </a-menu-item>

          <!-- 重命名文件夹 -->
          <a-menu-item key="rename" v-if="AUTH_ATTACH_DIR_RENAME">
            {{ $t('attach_menu_rename') }}
          </a-menu-item>

          <!-- 删除文件夹 -->
          <a-menu-item key="delete" class="delete-item" v-if="AUTH_ATTACH_DIR_DELETE">
            {{ $t('attach_menu_delete') }}
          </a-menu-item>
        </a-menu>
      </template>
    </a-dropdown>
  </div>
</template>

<script>
import attachAuth from '@/views/attach/mixins/attachAuth';

export default {
  mixins: [attachAuth],
  name: 'TreeNodeTitle',
  props: {
    title: {
      type: String,
      required: true,
    },
    record: {
      type: Object,
      required: true,
    },
    dirId: {
      type: Number,
    },
    customStyle: {
      type: Object,
      default: () => ({}),
    },
  },

  methods: {
    handleMenuClick({ key }) {
      this.$emit('command', {
        command: key,
        target: this.target,
        data: this.record,
      });
      this.visible = false;
    },
  },
};
</script>
<style lang="less" scoped>
.tree-intro {
  max-width: 240px;
  word-wrap: break-word;
  word-break: break-all;

  .tree-intro-content {
    margin-top: 10px;
    font-size: 14px;
    color: #666;
  }

  h5 {
    padding: 0;
    font-weight: bold;
    font-size: 16px;
    padding-top: 10px;

    &.tree-intro-title {
      border-bottom: #e8e8e8 solid 1px;
      padding-bottom: 5px;
      margin-bottom: 10px;
    }
  }
}

.attach-tree-node {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .ant-dropdown-trigger {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
